import { ActivatedRoute } from "@angular/router";
import { Injectable } from "@angular/core";

@Injectable()
export class ErrorIdProvider {
  getId(route: ActivatedRoute): string | undefined {
    return route.snapshot.paramMap.get("errorId") || undefined;
  }
}
